import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { api } from "../lib/api";
import { PendenciaDocsProvider } from "./PendenciaDocs";
import CedenteSidebar from "./CedenteSidebar";
import CedenteHeader from "./CedenteHeader";

// Bolinha de pendência (owner C1014323): o tipo de pessoa do cedente aprovado
// vem do CNPJ de /cedente/settings, a mesma fonte do aviso da aba Geral.
const cnpjDoCedente = () => api.get("/cedente/settings").then(({ data }) => data?.cnpj);

export default function CedenteLayout() {
  const [open, setOpen] = useState(false);
  return (
    <PendenciaDocsProvider resolveDoc={cnpjDoCedente}>
      <div className="min-h-screen bg-[var(--zemo-bg)] flex">
        <CedenteSidebar open={open} onClose={() => setOpen(false)} />
        <div className="flex-1 flex flex-col min-w-0">
          <CedenteHeader onOpenSidebar={() => setOpen(true)} />
          <main className="flex-1 px-4 lg:px-8 py-6 lg:py-8 max-w-[1600px] w-full mx-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </PendenciaDocsProvider>
  );
}
